export const PERCENTAGE_START_POINT = 100;
export const MIN_RANGE_VALUE = 0;
export const MAX_RANGE_VALUE = 100;
export const MIN_PERCENTAGE_VALUE = 25;
export const MAX_PERCENTAGE_VALUE = 200;
